import Dashboard from '../dashboard/Dashboard';

const Inicio = () => {
  return <Dashboard />;
};

export default Inicio;
